'use strict';

import {
	SET_POWER_BI_REPORT_TYPES,
	UPDATE_POWER_BI_REPORT_TYPES,
	RESET_POWER_BI_REPORT_TYPES,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './powerBIReportTypes.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		originalPowerBIReportType: {},
		powerBIReportType: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_POWER_BI_REPORT_TYPES: {
			return {
				...state,
				data: {
					...state.data,
					powerBIReportType: payload,
					originalPowerBIReportType: payload,
				},
			};
		}

		case UPDATE_POWER_BI_REPORT_TYPES: {
			return {
				...state,
				data: {
					...state.data,
					powerBIReportType: {
						...state.data.powerBIReportType,
						...payload,
					},
				},
			};
		}

		case RESET_POWER_BI_REPORT_TYPES: {
			return {
				...defaultState,
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
